import { useSearchParams } from 'react-router-dom';

const useQueryParams = (paramName: string) => {
  const [searchParams] = useSearchParams();
  const paramValue = searchParams.get(paramName);
  return paramValue;
};

export default useQueryParams;
